'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dScope$0024$0024anon$00249 from "./presto.types$-Dashboard-Scope$$anon$9.js";
var $p;
function $s_Lpresto_types$DashboardScope$__account__Lpresto_types$DashboardScope() {
  $m_Lpresto_types$DashboardScope$();
  return $t_Lpresto_types$DashboardScope$__account;
}
export { $s_Lpresto_types$DashboardScope$__account__Lpresto_types$DashboardScope as $s_Lpresto_types$DashboardScope$__account__Lpresto_types$DashboardScope };
function $s_Lpresto_types$DashboardScope$__all__Lpresto_types$DashboardScope() {
  $m_Lpresto_types$DashboardScope$();
  return $t_Lpresto_types$DashboardScope$__all;
}
export { $s_Lpresto_types$DashboardScope$__all__Lpresto_types$DashboardScope as $s_Lpresto_types$DashboardScope$__all__Lpresto_types$DashboardScope };
/** @constructor */
function $c_Lpresto_types$DashboardScope$() {
  this.c59 = null;
  this.c5a = false;
  $n_Lpresto_types$DashboardScope$ = this;
  $t_Lpresto_types$DashboardScope$__account = new $j_presto$002etypes$0024$002dDashboard$002dScope$0024$0024anon$00249.$c_Lpresto_types$DashboardScope$$anon$9(0, "account", this);
  $t_Lpresto_types$DashboardScope$__all = new $j_presto$002etypes$0024$002dDashboard$002dScope$0024$0024anon$00249.$c_Lpresto_types$DashboardScope$$anon$9(1, "all", this);
  $s_Lpresto_types$DashboardScope$__account__Lpresto_types$DashboardScope();
  $s_Lpresto_types$DashboardScope$__all__Lpresto_types$DashboardScope();
}
export { $c_Lpresto_types$DashboardScope$ as $c_Lpresto_types$DashboardScope$ };
$p = $c_Lpresto_types$DashboardScope$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardScope$;
/** @constructor */
function $h_Lpresto_types$DashboardScope$() {
}
export { $h_Lpresto_types$DashboardScope$ as $h_Lpresto_types$DashboardScope$ };
$h_Lpresto_types$DashboardScope$.prototype = $p;
$p.cR3 = (function(\u03b4name) {
  if ((\u03b4name === "account")) {
    return $s_Lpresto_types$DashboardScope$__account__Lpresto_types$DashboardScope();
  }
  if ((\u03b4name === "all")) {
    return $s_Lpresto_types$DashboardScope$__all__Lpresto_types$DashboardScope();
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
});
$p.cHN = (function() {
  if ((!this.c5a)) {
    this.c59 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((s) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$DashboardScope$().cR3(s));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa);
    this.c5a = true;
  }
  return this.c59;
});
var $d_Lpresto_types$DashboardScope$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardScope$, "presto.types$DashboardScope$", ({
  Zj: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$DashboardScope$ as $d_Lpresto_types$DashboardScope$ };
var $n_Lpresto_types$DashboardScope$;
function $m_Lpresto_types$DashboardScope$() {
  if ((!$n_Lpresto_types$DashboardScope$)) {
    $n_Lpresto_types$DashboardScope$ = new $c_Lpresto_types$DashboardScope$();
  }
  return $n_Lpresto_types$DashboardScope$;
}
export { $m_Lpresto_types$DashboardScope$ as $m_Lpresto_types$DashboardScope$ };
var $t_Lpresto_types$DashboardScope$__account = null;
function $u_Lpresto_types$DashboardScope$__account(x) {
  $t_Lpresto_types$DashboardScope$__account = x;
}
export { $t_Lpresto_types$DashboardScope$__account as $t_Lpresto_types$DashboardScope$__account, $u_Lpresto_types$DashboardScope$__account as $u_Lpresto_types$DashboardScope$__account };
var $t_Lpresto_types$DashboardScope$__all = null;
function $u_Lpresto_types$DashboardScope$__all(x) {
  $t_Lpresto_types$DashboardScope$__all = x;
}
export { $t_Lpresto_types$DashboardScope$__all as $t_Lpresto_types$DashboardScope$__all, $u_Lpresto_types$DashboardScope$__all as $u_Lpresto_types$DashboardScope$__all };
//# sourceMappingURL=presto.types$-Dashboard-Scope$.js.map
